export const HistoryTitle = ({ displayedHistory, ratingFilter }) => {
  const getTitleText = () => {
    const count = displayedHistory.length;
    const albumText = count === 1 ? "album" : "albums";
    
    if (ratingFilter === null) {
      return `${count} ${albumText}`;
    }
    if (ratingFilter === 'did-not-listen') {
      return count === 0 ? "Zero albums" : `${count} ${albumText}`;
    }
    if (ratingFilter === 0) {
      return count === 0 ? "Zero albums" : `${count} ${albumText}`;
    }
    const stars = [...Array(ratingFilter)].map((_, i) => (
      <span key={i} className="material-symbols-outlined xl:text-[6.75rem] lg:text-[5.75rem] md:text-[4rem] text-[2.75rem]">star</span>
    ));
    return count === 0 ? (
      <>Zero albums</>
    ) : (
      <span className="inline-flex flex-wrap items-center justify-center gap-1">
        {stars}
        <span>{count} {albumText}</span>
      </span>
    );
  };

  return (
    <div className="flex flex-row md:gap-4 gap-2 items-center justify-center w-full px-8 py-4
      text-center pangram-sans-bold text-amber-50
      xl:text-[8rem] lg:text-[6.5rem] md:text-[4.5rem] text-[3rem]
      xl:leading-[7rem] lg:leading-[5.5rem] md:leading-[3.75rem] leading-[2.5rem]">
      {getTitleText()}
    </div>
  );
};